import React, { useState } from "react";
import axios from "axios";

const ImageSelector = ({ onSelect }) => {
    const [availableImages, setAvailableImages] = useState([]);
    const [showImageSelector, setShowImageSelector] = useState(false);

    const fetchImages = async (subfolder = "") => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get("/api/images/list-images", {
                params: { subfolder },
                headers: { Authorization: `Bearer ${token}` },
            });
            setAvailableImages(response.data.images);
            setShowImageSelector(true);
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    return (
        <>
            <button
                onClick={() => fetchImages()}
                className="bg-blue-500 text-white px-2 py-1 rounded"
            >
                Show Existing Images
            </button>

            {showImageSelector && (
                <div className="image-selector-overlay">
                    <div className="image-selector">
                        <div className="image-selector-header">
                            <h4>Select Image</h4>
                            <button
                                onClick={() => setShowImageSelector(false)}
                                className="close-button"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="existing-images-grid">
                            {availableImages.map((item, idx) =>
                                item.isDirectory ? (
                                    <button
                                        key={idx}
                                        onClick={() => fetchImages(item.path)}
                                        className="folder-button"
                                    >
                                        📁 {item.name}
                                    </button>
                                ) : (
                                    <img
                                        key={idx}
                                        src={`/assets/images/blog/${item.path}`}
                                        alt="Available"
                                        onClick={() => {
                                            onSelect(`/assets/images/blog/${item.path}`);
                                            setShowImageSelector(false);
                                        }}
                                        className="existing-image"
                                    />
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ImageSelector;
